import { actionCreator } from '@ardoq/rxbeach';
import { APIComponentAttributes, ArdoqId } from '@ardoq/api-types';
import type { EnhancedScopeData } from '@ardoq/data-model';
import { NewEntityAttributes } from 'scopeData/scopeEditUtils/types';
import { GetContentOptions } from 'appModelStateEdit/legacyTypes';
import { PropertyGroup } from './propertiesEditor/types';
import type { EditableEntityType } from './types';

export type BeginEditWorkflowPayload = {
  readonly entityType: EditableEntityType;
  readonly entityIDs: ArdoqId[];
  readonly options: GetContentOptions;
  readonly model?: ArdoqId;
  readonly isEditingComponentStyle?: boolean;
  readonly enhancedScopeData: EnhancedScopeData;
};

export type BeginCreateWorkflowPayload = BeginEditWorkflowPayload & {
  readonly newEntityAttributes: NewEntityAttributes[];
  readonly enhancedScopeData: EnhancedScopeData;
};

export type SetEnhancedScopeDataPayload = {
  readonly enhancedScopeData: EnhancedScopeData;
};

export type CreateEntitiesPayload = {
  readonly propertyGroups: PropertyGroup[];
};

export const beginEditWorkflow = actionCreator<BeginEditWorkflowPayload>(
  '[appModelStateEdit] BEGIN_EDIT_WORKFLOW'
);

export const beginCreateWorkflow = actionCreator<BeginCreateWorkflowPayload>(
  '[appModelStateEdit] BEGIN_CREATE_WORKFLOW'
);

export const finishWorkflow = actionCreator(
  '[appModelStateEdit] FINISH_WORKFLOW'
);

export const finishWorkflowReducer = actionCreator(
  '[appModelStateEdit] FINISH_WORKFLOW_REDUCER'
);

export const repeatLatestWorkflow = actionCreator(
  '[appModelStateEdit] REPEAT_LATEST_WORKFLOW'
);

export const setEnhancedScopeData = actionCreator<SetEnhancedScopeDataPayload>(
  '[appModelStateEdit] SET_ENHANCED_SCOPED_DATA'
);

export const saveEditedEntities = actionCreator(
  '[appModelStateEdit] SAVE_EDITED_ENTITIES'
);

export const createEntities = actionCreator<CreateEntitiesPayload>(
  '[appModelStateEdit] CREATE_ENTITIES'
);

export const scenarioComponentsSaved = actionCreator<APIComponentAttributes[]>(
  '[appModelStateEdit] SCENARIO_COMPONENTS_SAVED'
);
